<section class="new_dashboard" *ngIf="!loader">
   <div class="wel_sectionm" *ngIf="businessListData.length == 0 && !isForDashboard">
      <mat-card appearance="outlined" style="border:none !important">
       <h3>Welcome, {{userDetail.name}}</h3>
         <p>Let's start your journey with creating a new business or professional service. You can add one or many. </p>
         <p>Start using the platform features, functionality and see a rocketing growth in your business.</p>
         <div class="Create_new_business_btn" style="margin-top: 10px;display: flex;">
           <div class="newd_seb">
            <button (click)="selectcountry()" mat-stroked-button color="primary">
               <mat-icon>add</mat-icon>
                New business
            </button>
           </div>
           <div class="newd_help">
            <button mat-stroked-button color="primary" (click)="openvideo()">
             Help video
           </button>
        </div>
         </div>
      </mat-card>
   </div>

   <div class="welcome_heading" *ngIf="businessListData.length > 0 && !isForDashboard">
     <div class="business_bth">
     <h3>Welcome, {{userDetail.name}}</h3>
     <p>{{userDetail.addressInfo ? userDetail.addressInfo.address_line : 'No address info'}}</p>
   </div>
 </div>
 <div class="row dashboard_card" *ngIf="businessListData.length > 0">
   <div class="card-container ">
    <div class="row">
    <div class="col-6" (click)="openadded()">
     <div class="custom-task-card custom-task-added">
       <span class="material-icons custom-task-icon">list</span>
       <span class="custom-task-number">{{tasksCount?.assigned_tasks}}</span>
       <div class="tesk_heading">Task added</div>
       <div class="assign_para" style="font-size: 12px;"> Bookings or members assigned to you.</div>
        <div class="arrow_crdf" *ngIf="tasksCount?.assigned_tasks > 0">
            <mat-icon>arrow_forward</mat-icon>
          </div>
     </div>
    </div>
    <div class="col-6" (click)="opencompleted()">
     <div class="custom-task-card custom-task-complete">
       <span class="material-icons custom-task-icon" style="color: #CE125C;">check</span>
       <span class="custom-task-number">{{tasksCount?.completed_tasks}}</span>
       <div class="tesk_heading">Task complete</div>
       <div class="assign_para" style="font-size: 12px;">Assigned job done so far today by you.</div>
          <div class="arrow_crdf" *ngIf="tasksCount?.completed_tasks > 0">
            <mat-icon>arrow_forward</mat-icon>
          </div>
     </div>
    </div>
   </div>
  </div>
  <div class="col-sm-6 col-6">
   <sm-todays-bookings></sm-todays-bookings>
  </div>
  <div class="col-sm-6 col-6">
   <sm-upcoming-appointments></sm-upcoming-appointments>
  </div>
  <div class="col-sm-6 col-6">
   <sm-unpaid-invoices></sm-unpaid-invoices>
  </div>
  <div class="col-sm-6 col-6">
   <sm-latest-purchases></sm-latest-purchases>
  </div>
  <div class="col-sm-6 col-6">
     <sm-inventory-status></sm-inventory-status>
  </div>
  <div class="col-sm-6 col-6">
   <sm-employee-log></sm-employee-log>
  </div>
</div>



<!-- placeholder section -->

<div class="placeholder_im_ggt" *ngIf="businessListData.length == 0 && !isForDashboard">
  <img src="../../../../assets/images/business_profile_empty_placeholder.png" />
</div>
<!-- placeholder section -->



           <!-- open Messaging section -->
           
       
           <!-- open Messaging section end -->
            <div class="floting_button_ttr">
              <div class="example-button-container">
                 <button mat-fab color="warn" [matMenuTriggerFor]="menu" aria-label="more">
                   <mat-icon>add</mat-icon>
                 </button>
               </div>
               
               <mat-menu #menu="matMenu">
                 <button mat-menu-item (click)="Newbooking()">
                   <mat-icon class="material-icons-outlined">person_add</mat-icon> Booking / Query
                 </button>
                  <button mat-menu-item (click)="addenrollmember()">
                    <mat-icon class="material-icons-outlined">diversity_3</mat-icon>Enroll new member
                 </button>
                 <button mat-menu-item (click)="createNewBill()">
                   <mat-icon class="material-icons-outlined">post_add</mat-icon> Bill / Invoice
                 </button>
               </mat-menu>
               
           </div>

</section>